import { useRef, useState, useEffect } from "react";
import "./Services01.css";

import b2b from "./../../../img/icons/b2b-green.svg";
import truck from "./../../../img/icons/truck-green.svg";
import recycling from "./../../../img/icons/recycling2-green.svg";
import arrow from "./../../../img/icons/arrow-green.svg";

function Services01() {
  return (
    <div className="Services01 section" id="Services01">
      <div className="container">
        <div className="intro">
          <p className="eyebrow grey">Our Services</p>
          <h2>Comprehensive Tyre Recycling Services</h2>
          <p>
            We offer a complete solution for your waste tyre management needs.
            We ensure your end-of-life tyres are handled responsibly,
            compliantly, and in an environmentally effective way, turning waste
            into valuable resources.
          </p>
        </div>
        <div className="Services01-box">
          <div>
            <img src={b2b} alt="" />
            <h3>Scheduled B2B Collections </h3>
            <p>
              For businesses with a regular output of waste tyres, such as
              garages, dealerships, and fleet depots. We provide scheduled,
              reliable collections to fit your workflow, ensuring your site
              remains clear and compliant.
            </p>
          </div>

          <div>
            <img src={truck} alt="" />
            <h3>On-Demand & Bulk Collections </h3>
            <p>
              Ideal for site clearances, agricultural waste, or large one-off
              disposals. Our flexible logistics team can arrange for bulk
              collections anywhere in the UK, providing all necessary tools and
              documentation.
            </p>
          </div>

          <div>
            <img src={recycling} alt="" />
            <h3>On-Site Tyre Disposals </h3>
            <p>
              For remote projects or locations, our specialist team can perform
              on-site processing and removal. We bring the equipment to you,
              ensuring safe, compliant, and efficient clearance of even the most
              challenging sites.
            </p>
          </div>

          <div>
            <img src={arrow} alt="" />
            <h3>Post-Processing Materials </h3>
            <p>
              We are providing high-quality, sustainably sourced materials from
              recycled tyres. Including Equestrian Rubber, Tyre Derived Fuel
              (TDF/Shreds), Tyre Sidewalls for silage clamps, and high-tensile
              Tyre Wire / Steel.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services01;
